<template>
  <div ref="container" class="resize-container">
    <slot :size="size"></slot>
  </div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'ResizeContainer',
  data() {
    return {
      observer: null,
      size: { width: 0, height: 0 }
    }
  },
  mounted() {
    this.observer = new ResizeObserver(this.resizeFunc)
    this.observer.observe(this.$refs.container)
    window.addEventListener('resize', this.resizeFunc)
    // this.$nextTick(this.resizeFunc)
  },
  methods: {
    resizeFunc() {
      const container = this.$refs.container
      if (!container) return
      this.size = container.getBoundingClientRect()
      this.$emit('resizeFunc', this.size)
    },
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.container)
    window.removeEventListener('resize', this.resizeFunc)
  }
}
</script>

<style lang="scss" scoped>
.resize-container,
.resize-iframe {
  width: 100%;
  height: 100%;
}

.resize-container {
  position: relative;
  height: 0;
}

.resize-iframe {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  min-height: 1px;
}
</style>
